//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services.js";
import StocksDSVTable from "@/pages/SalesDashboard/components/StocksDSVTable.vue";
import { EventBus } from "@/event-bus.js";
import { fileNameFromAttachment } from "@/utils/name-parser.js";

// import SalesStockTable from "@/pages/SalesDashboard/components/SalesStockTable.vue";

export default {
  name: "StocksData",
  props: [
    "selectedRetailer",
    "retailerList",
    "fields",
    "fieldId",
    "startDate",
    "endDate",
    "productHierarchyElementId",
    "storeHierarchyElementId",
    "geoHierarchyElementId",
    "productIds",
    "storeIds",
    "employeeId",
    "employeeName",
    "employees"
  ],
  components: {
    StocksDSVTable,
    // SalesStockTable,
  },
  beforeMount: function () {
    let currentDay = moment().startOf("day");
    if (this.startDate.isSame(currentDay)) {
      this.initStartDate = this.startDate.clone();
      this.initStartDate.subtract(1, "month");
    } else {
      this.initStartDate = this.startDate;
    }
  },
  mounted: function () {
    this.calculateWeeks();
    this.getDWS();
  },
  data: () => ({
    stocksDwsData: [],
    stocksDws: "minus7",
    stocksSalesData: [],
    isLoadingDwsa: false,
    isLoadingStocks: false,
    weekNumberList: [],
    weekNumber: null,
    recordsTotalDwsa: null,
    recordsTotalStocks: null,
    initStartDate: null,
    lowerTableIcon: "mdi-chevron-down",
    showLowerTable: false,
    stocksPagination: {
      page: 1,
      rowsPerPage: 10,
    },
    dwsaPagination: {
      page: 1,
      rowsPerPage: 10,
    },
    customFilters: {
      daysWithoutSales: null,
      daysCoverage: null,
      abcSelected: null,
      cardexStatus: null,
    },
    selectedEmployee: null,
  }),
  methods: {
    exportTable: function () {
      BackendServices.downloadDaysWithoutSales(
        this.endDate,
        this.stocksDws,
        this.productHierarchyElementId,
        this.storeHierarchyElementId,
        this.geoHierarchyElementId,
        this.productIds,
        this.storeIds,
        this.employeeId,
        this.selectedRetailer,
        this.customFilters,
        this.dwsaPagination.page,
        this.dwsaPagination.rowsPerPage
      ).then((response) => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        let fileName = fileNameFromAttachment(response.headers["content-disposition"]);
        link.setAttribute("download", fileName); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    calculateWeeks: function () {
      const startDateWeek = this.initStartDate.startOf("week");
      this.weekNumberList.splice(0, this.weekNumberList.length);

      let i = 1;

      let currentDay = moment(startDateWeek.format("YYYY-MM-DD"), "YYYY-MM-DD");

      while (currentDay.isSameOrBefore(this.endDate)) {
        this.weekNumberList.push({
          label: `${i}ª Semana`,
          value: currentDay.isoWeek(),
          year: currentDay.year(),
        });
        i++;
        currentDay.add(1, "weeks");
      }

      this.weekNumber = this.endDate.isoWeek();
    },
    askForDataDwsa: function (event) {
      this.dwsaPagination.page = event.pagination.page;
      this.dwsaPagination.rowsPerPage = event.pagination.rowsPerPage;
      this.getDWS();
    },
    askForDataStocks: function (event) {
      this.stocksPagination.page = event.pagination.page;
      this.stocksPagination.rowsPerPage = event.pagination.rowsPerPage;
      this.getStockSalesByDay();
    },
    getDWS: function () {
      this.isLoadingDwsa = true;
      BackendServices.kpis
        .getStocksDaysWithoutSales(
          this.endDate,
          this.stocksDws,
          this.productHierarchyElementId,
          this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeIds,
          this.employeeId,
          this.selectedRetailer,
          this.customFilters,
          this.dwsaPagination.page,
          this.dwsaPagination.rowsPerPage
        )
        .then((response) => {
          this.stocksDwsData = response.data;
          this.isLoadingDwsa = false;
          this.recordsTotalDwsa = Number(response.headers["x-total-count"]);
        });
    },
    getStockSalesByDay: function () {
      // if (this.showLowerTable) {

      //   this.isLoadingStocks = true;
      //   BackendServices.kpis
      //     .getStocksAndSalesByDay(
      //       this.weekNumber,
      //       this.weekNumberList.find((e) => e.value === this.weekNumber).year,
      //       this.productHierarchyElementId,
      //       this.storeHierarchyElementId,
      //       this.geoHierarchyElementId,
      //       this.productIds,
      //       this.storeIds,
      //       this.employeeId,
      //       this.selectedRetailer,
      //       this.stocksPagination.page,
      //       this.stocksPagination.rowsPerPage
      //     )
      //     .then((response) => {
      //       this.stocksSalesData = response.data;
      //       this.recordsTotalStocks = Number(response.headers["x-total-count"]);
      //       this.isLoadingStocks = false;
      //     });
      // }
    },
    toggleShowTable: function () {
      if (this.showLowerTable) {
        this.showLowerTable = !this.showLowerTable;
        this.lowerTableIcon = "mdi-chevron-down";
      } else {
        this.showLowerTable = !this.showLowerTable;
        this.getStockSalesByDay();
        this.lowerTableIcon = "mdi-chevron-up";
      }

    },
  },
  watch: {
    isLoadingDwsa: function (val) {
      EventBus.$emit("loadingState", val);
    },
    selectedRetailer: {
      handler: function () {
        this.getDWS();
        this.getStockSalesByDay();
      },
    },
    productHierarchyElementId: {
      handler: function () {
        this.getDWS();
        this.getStockSalesByDay();
      },
    },
    storeIds: {
      handler: function () {
        this.getDWS();
        this.getStockSalesByDay();
      },
    },
    productIds: {
      handler: function () {
        this.getDWS();
        this.getStockSalesByDay();
      },
    },

    storeHierarchyElementId: {
      handler: function () {
        this.getDWS();
        this.getStockSalesByDay();
      },
    },
    geoHierarchyElementId: {
      handler: function () {
        this.getDWS();
        this.getStockSalesByDay();
      },
    },
    endDate: {
      handler: function () {
        let currentDay = moment().startOf("day");
        if (this.startDate.isSame(currentDay)) {
          this.initStartDate = this.startDate.clone();
          this.initStartDate.subtract(1, "month");
        } else {
          this.initStartDate = this.startDate;
        }
        this.calculateWeeks();
        this.getDWS();
        this.getStockSalesByDay();
      },
    },
    employeeId: {
      handler: function () {
        //select from array the object wioth id given
        this.selectedEmployee = this.employees.find(
          (e) => e.id === this.employeeId
        );
        this.getDWS();
        this.getStockSalesByDay();
      },
    },
    stocksDws: {
      handler: function () {
        this.getDWS();
      },
    },
    weekNumber: {
      handler: function () {
        this.getStockSalesByDay();
      },
    },
    "$store.getters.getCoverageDaysView": {
      handler(value) {
        this.customFilters.daysCoverage = value;
        this.getDWS();
      },
    },
    "$store.getters.getDaysWithoutSales": {
      handler(value) {
        this.customFilters.daysWithoutSales = value;
        this.getDWS();
      },
    },
    "$store.getters.getAbcSelected": {
      handler(value) {
        this.customFilters.abcSelected = value;
        this.getDWS();
      },
      deep: true,
    },
    "$store.getters.getCardexStatus": {
      handler(value) {
        this.customFilters.cardexStatus = value;
        this.getDWS();
      },
      deep: true,
    },
  },


};
